
import { UserAuditEventEntityDecoratorBase } from './user-audit-event.decorator.base';


export class UserAuditEventEntityDecorator extends UserAuditEventEntityDecoratorBase {
  constructor() {
    super();
  }
}



